import { render, staticRenderFns } from "./RecupPassword.vue?vue&type=template&id=35598eb9&"
import script from "./RecupPassword.vue?vue&type=script&lang=js&"
export * from "./RecupPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PROJETS\\VITISSIA\\2024\\vitissiapro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35598eb9')) {
      api.createRecord('35598eb9', component.options)
    } else {
      api.reload('35598eb9', component.options)
    }
    module.hot.accept("./RecupPassword.vue?vue&type=template&id=35598eb9&", function () {
      api.rerender('35598eb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/RecupPassword.vue"
export default component.exports